import React, { useState } from "react";
import { Box, Checkbox, TableCell, TableRow, Tooltip } from "@mui/material";
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon, } from "@mui/icons-material";
import moment from "moment";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { PermissionWrapper } from "../../../../wrappers";
import { trackActivity } from "../../../../utils/mixpanel";
import UploadingIcon from "../../../../shared_elements/components/UploadingIcon";
import { dateMonthYearDateFormat } from "../../../../constants";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AuditPopover from "../../../../shared_elements/components/popover";
import LessMoreComp from "../../../../shared_elements/components/CustomLessMoreComp";

const SupplementList = ({ item, bulk, onEditFn, viewRevisonHistory, uploadedFileData, slug, uploadFileProgressData, onView, onDeleteEolFn, toggleBulkOps, onOpenAttachments, viewFileStatus }) => {

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Supplement Listing`, page_type: page_type, })
  }
  return (
    <TableRow >
      <TableCell className="table-actions-list">
        <Box className="table-icon-container">
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['D'] }}>
            <Checkbox disableRipple style={{ verticalAlign: 'super' }} color="primary" size='small' checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={toggleBulkOps} />
          </PermissionWrapper>
          <AuditPopover item={item}>
            <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
          </AuditPopover>
          <Tooltip title="Revision History"><RestoreIcon className="revision-history" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: 'pointer' }} fontSize='small' color='primary' /></Tooltip>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['R'] }}>
            <Tooltip title="View"><VisibilityIcon sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('ViewIcon') }} fontSize='small' color='primary' /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['U'] }}>
            <Tooltip title="Edit"><EditIcon sx={{ cursor: 'pointer' }} onClick={() => { onEditFn(); handleItemClicked('EditIcon') }} fontSize='small' color='primary' /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['D'] }}>
            <Tooltip title="Delete"><DeleteIcon sx={{ cursor: 'pointer' }} onClick={() => { onDeleteEolFn(); handleItemClicked('DeleteIcon') }} fontSize='small' color='error' /></Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "supplement", operationType: ['R'] }}>
            
              {
                item?.attachments?.length > 0 && (
                  <Tooltip title="Attached File(s)">
                    <Box className="attachment-container">
                    <AttachFileIcon fontSize="small" color="primary" onClick={() => { onOpenAttachments(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                      <Box className="attachment-count"> ({item.attachments.length}) </Box>
                    </Box>
                  </Tooltip>
                )
              }
            
          </PermissionWrapper>
         { (slug === item?.slug) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
        </Box>
      </TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.date ? moment(item.date).format(dateMonthYearDateFormat) : "--"}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.unique_identifier || "--"}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}> <div style={{ width: item?.executed_by?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.executed_by} lessMr='executed_by' /></div></TableCell>
    </TableRow>
  );
};

export default SupplementList;
